import {
  Input as ChakraInput,
  InputProps as ChakraInputProps,
} from '@chakra-ui/react';

import {
  FormFieldUncontrolledComponent,
  FormFieldUncontrolledComponentProps,
} from '../../types/fields';

type HiddenProps = ChakraInputProps;

export const Hidden: FormFieldUncontrolledComponent<HiddenProps> = ({
  _ref,
  className,
  ...props
}: FormFieldUncontrolledComponentProps<HiddenProps>) => (
  <ChakraInput
    ref={_ref}
    className={className}
    id={props.name}
    type="hidden"
    {...props}
  />
);

Hidden.controlled = false;
Hidden.displayName = 'Hidden';
